import { BhAdPopupComponentModule } from './../../components/bh-ad-popup/bh-ad-popup.component.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RemindersAdPage } from './reminders-ad.page';
import { RemindersAdPageRoutingModule } from './reminders-ad-routing.module';

@NgModule({
  imports: [
    BhAdPopupComponentModule,
    CommonModule,
    FormsModule,
    IonicModule,
    RemindersAdPageRoutingModule
  ],
  declarations: [RemindersAdPage]
})
export class RemindersAdPageModule {}
